var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 24.5,
    rx: 24,
    ry: 24.5,
    fill: "#09041C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1173 23.1984L32.4459 16H30.9463L25.4511 22.2502L21.0621 16H16L22.6369 25.4514L16 33H17.4998L23.3028 26.3996L27.9378 33H33L26.1173 23.1984ZM24.0631 25.5347L23.3907 24.5935L18.0402 17.1047H20.3437L24.6616 23.1485L25.3341 24.0896L30.947 31.9456H28.6435L24.0631 25.5347Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.743c470ba60cb4e44205ad584d0fdd3d.svg";
export { ForwardRef as ReactComponent };